// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"a143bd88","165":"67579367"}[chunkId] + ".chunk.js";
};